import _ from 'underscore'
import Vue from 'vue'
import UserSearch from '../../resources/userSearch'

const utils = {
  resetState(state) {
    state.userSearchResults = [];
    state.showNoResultsMessage = false;
  },
}


const state = {
  userSearchResults: [],
  showNoResultsMessage: false,
};
utils.resetState(state);

const getters = {
  userSearchResults(state) {
    return _.values(state.userSearchResults);
  },
  showNoResultsMessage(state) {
    return state.showNoResultsMessage;
  }
}

const actions = {
  searchUsers(context, props) {
    UserSearch.query({ search: props.searchTerm }).then((res) => {
      context.commit(`RETRIEVE_SEARCH_SUCCESS`, { user: res.data });
      if (_.isFunction(props.callback)) props.callback(null, res.data);
    }, (res) => {
      Toast.error('Failed to find user');
    })
  },
  clearSearch(context) {
    context.commit(`CLEAR_SEARCH_RESULTS`, {});
  },
}

const mutations = {
  LOGOUT_SUCCESS() {
    // Clear state
    utils.resetState(state);
  },

  RETRIEVE_SEARCH_SUCCESS(state, payload) {
    if (payload.user) {
      state.userSearchResults = payload.user;
      state.showNoResultsMessage = state.userSearchResults.length <= 0;
    }
  },

  CLEAR_SEARCH_RESULTS(state, payload) {
    state.userSearchResults = [];
    state.showNoResultsMessage = false;
  },
}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user-search.js